
import { Component, Prop, Vue } from 'vue-property-decorator';


@Component({
  name: 'MsgLoad',
  components: {
  },
})
class MsgLoad extends Vue {
  @Prop({ default: false }) isLoading:boolean|undefined;
}
export default MsgLoad;
